import { z } from 'zod';
import { CAPABILITIES, SCOPES } from './capabilities.js';
import { objectIdSchema } from './common.js';
export const capabilitySchema = z.enum(CAPABILITIES);
export const scopeSchema = z.enum(SCOPES);
export const grantSchema = z.object({
    capability: capabilitySchema,
    scope: scopeSchema,
});
/**
 * Кастомная роль создаётся КЛОНИРОВАНИЕМ системной, а не с чистого листа:
 * реальный запрос звучит как «как менеджер, но без экспорта».
 */
export const createRoleSchema = z.object({
    name: z.string().min(1).max(120),
    description: z.string().max(500).default(''),
    clonedFromKey: z.string().min(1).max(64),
    grants: z.array(grantSchema).min(1),
});
export const updateRoleSchema = z.object({
    name: z.string().min(1).max(120).optional(),
    description: z.string().max(500).optional(),
    grants: z.array(grantSchema).min(1).optional(),
});
export const roleSchema = z.object({
    id: objectIdSchema,
    orgId: objectIdSchema.nullable(),
    key: z.string(),
    name: z.string(),
    description: z.string(),
    isSystem: z.boolean(),
    level: z.number().int(),
    grants: z.array(grantSchema),
    createdAt: z.coerce.date(),
});
export const assignRoleSchema = z.object({
    userId: objectIdSchema,
    roleId: objectIdSchema,
    siteIds: z.array(objectIdSchema).nullable(),
});
//# sourceMappingURL=role.js.map